export const WRITE_PROPOSAL_PREFIX = "MCP_WRITE_PROPOSAL:";

export type McpWriteProposal = {
  tool: string;
  arguments: Record<string, unknown>;
  /** Signed one-time propose-step token from the Backoffice agent BFF. */
  token: string;
};

export function writeProposalReviewLabel(tool: string): string {
  switch (tool) {
    case "create_person_note":
      return "staff note proposal";
    case "create_interaction":
      return "CRM interaction proposal";
    default:
      return "write proposal";
  }
}

export function parseWriteProposal(text: string): McpWriteProposal | null {
  const index = text.lastIndexOf(WRITE_PROPOSAL_PREFIX);
  if (index === -1) {
    return null;
  }

  try {
    const parsed = JSON.parse(text.slice(index + WRITE_PROPOSAL_PREFIX.length)) as Partial<McpWriteProposal>;
    if (
      !parsed?.tool ||
      typeof parsed.arguments !== "object" ||
      parsed.arguments === null ||
      Array.isArray(parsed.arguments) ||
      typeof parsed.token !== "string" ||
      parsed.token.trim() === ""
    ) {
      return null;
    }

    return {
      tool: parsed.tool,
      arguments: parsed.arguments,
      token: parsed.token
    };
  } catch {
    return null;
  }
}

export function stripWriteProposalMarker(text: string): string {
  const index = text.lastIndexOf(WRITE_PROPOSAL_PREFIX);
  if (index === -1) {
    return text;
  }

  return text.slice(0, index).trimEnd();
}

export function writeProposalKey(proposal: McpWriteProposal): string {
  return `${proposal.tool}:${JSON.stringify(proposal.arguments)}`;
}

/** Confirmation identity for one assistant message's proposal (allows same payload later). */
export function confirmedWriteProposalKey(messageId: string, proposal: McpWriteProposal): string {
  return `${messageId}:${writeProposalKey(proposal)}`;
}

/**
 * Renders the argument object staff review before Confirm.
 * Omits the signed `token` — that value is forwarded as `proposal_token` on execute_write only.
 */
export function formatWriteProposalSummary(proposal: McpWriteProposal): string {
  return JSON.stringify(proposal.arguments, null, 2);
}
